// extracted by mini-css-extract-plugin
module.exports = {"bioForm":"RegistrationForm_bioForm__34P9s","bioFormStandalone":"RegistrationForm_bioFormStandalone__3gz8w"};